<template>
  <div id="app">
    <header
      class="header"
      :style="showWanasaLogo ? 'background:#fff' : ''"
      v-if="
        routeName !== '/qrCode' &&
          routeName !== '/details' &&
          routeName !== '/showtime'
      "
    >
      <div class="header-left">
        <button
          v-if="
            routeName !== '/' &&
              routeName !== '/login' &&
              routeName !== '/manual' &&
              routeName !== '/home'
          "
          class="btn-sidebar"
          @click="sidebar = !sidebar"
        >
          <img src="@/assets/img/hamburger.png" height="30" width="30" />
        </button>

        <button
          class="btn-sidebar"
          v-if="routeName === '/manual'"
          @click="$router.go(-1)"
        >
          <img src="@/assets/img/arrow_back.svg" />
        </button>
      </div>
      <div class="header-center">
        <img
          v-if="isMifClient"
          src="@/assets/img/brij.png"
          height="auto"
          width="100"
          alt="Brij-Logo"
        />
        <img
          v-else-if="!showWanasaLogo"
          src="@/assets/img/Nuvio_Primary Logo.png"
          height="auto"
          width="80"
          alt="Brij-Logo"
        />
        <img
          v-if="showWanasaLogo"
          src="@/assets/img/wanasaImage.png"
          height="auto"
          width="130"
          class="login-brand"
        />
      </div>
      <div class="header-right">
        <!-- Settings gear icon -->
        <div class="settings-wrapper" v-click-outside="closeSettingsDropdown">
          <button
            class="btn-settings"
            @click="settingsDropdownOpen = !settingsDropdownOpen"
            title="Settings"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#032D6E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
            </svg>
          </button>

          <!-- Settings dropdown -->
          <div class="settings-dropdown" v-if="settingsDropdownOpen">
            <div class="settings-dropdown-item" @click="openDefaultPageModal">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right:8px;">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
              Set Default Page
            </div>
          </div>
        </div>

        <button
          class="logout-btn"
          v-if="routeName === '/home'"
          @click="onLogout()"
        >
          Logout
        </button>
      </div>
    </header>

    <!-- Default Page Selection Modal -->
    <div class="settings-modal-overlay" v-if="showDefaultPageModal" @click.self="closeDefaultPageModal">
      <div class="settings-modal">
        <div class="settings-modal-header">
          <h4>Set Default Page</h4>
          <button class="settings-modal-close" @click="closeDefaultPageModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <p class="settings-modal-desc">Choose which page to land on after login:</p>
        <div class="settings-modal-options">
          <div
            class="settings-option"
            :class="{ 'settings-option-active': selectedDefaultPage === 'manual' }"
            @click="selectedDefaultPage = 'manual'"
          >
            <div class="settings-option-radio">
              <div class="settings-option-radio-inner" v-if="selectedDefaultPage === 'manual'"></div>
            </div>
            <div class="settings-option-content">
              <div class="settings-option-title">Manual Entry</div>
              <div class="settings-option-subtitle">Enter ticket IDs manually</div>
            </div>
          </div>
          <div
            class="settings-option"
            :class="{ 'settings-option-active': selectedDefaultPage === 'qrCode' }"
            @click="selectedDefaultPage = 'qrCode'"
          >
            <div class="settings-option-radio">
              <div class="settings-option-radio-inner" v-if="selectedDefaultPage === 'qrCode'"></div>
            </div>
            <div class="settings-option-content">
              <div class="settings-option-title">QR Scanner</div>
              <div class="settings-option-subtitle">Scan QR codes with camera</div>
            </div>
          </div>
        </div>
        <button class="btn-app-submit settings-modal-save" @click="saveDefaultPage">
          Save Preference
        </button>
      </div>
    </div>

    <aside
      v-if="routeName !== '/' && routeName !== '/login'"
      :class="['app-aside', sidebar ? 'active' : null]"
    >
      <!-- <router-link to="qrCode">QR Code</router-link>
      <hr class="my-0" /> -->
      <router-link @click.native="onLogout" to>Logout</router-link>

      <div class="d-flex justify-content-center position-absolute fixed-bottom">
        <p>v{{ this.version }}</p>
      </div>
    </aside>
    <div class="backdrop" v-if="sidebar" @click="sidebar = !sidebar"></div>
    <router-view></router-view>
  </div>
</template>

<script>
import { version } from "../package.json";
import BookingService from "@/services/BookingService";
export default {
  name: "app",
  directives: {
    'click-outside': {
      bind(el, binding) {
        el.__clickOutsideHandler = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.addEventListener('click', el.__clickOutsideHandler);
      },
      unbind(el) {
        document.removeEventListener('click', el.__clickOutsideHandler);
        delete el.__clickOutsideHandler;
      }
    }
  },
  data() {
    return {
      version,
      sidebar: false,
      showWanasaLogo: false,
      entry_id_required: "N",
      settingsDropdownOpen: false,
      showDefaultPageModal: false,
      selectedDefaultPage: "manual",
    };
  },
  beforeMount() {
    this.GetGlobalOptions();
    this.showWanasaLogo = window.location.origin.includes("wanasa");
    // Load current default page preference from cookie
    const savedDefault = this.$cookie.get("BRIJ_DEFAULT_PAGE");
    if (savedDefault) {
      this.selectedDefaultPage = savedDefault;
    }
  },
  computed: {
    routeName: function ß() {
      return this.$route.path;
    },
    isQfxClient() {
      if (window.localStorage.getItem("CLIENT_NAME")) {
        return (
          window.localStorage.getItem("CLIENT_NAME").toLowerCase() === "qfx"
        );
      } else if (window.location.origin.includes("qfx")) {
        return true;
      } else {
        return false;
      }
    },
    isMifClient() {
      if (typeof window === "undefined") return false;

      const clientName = window.localStorage.getItem("CLIENT_NAME");

      if (clientName) {
        return clientName.toLowerCase() === "mif";
      }

      return window.location.origin.toLowerCase().includes("mif");
    }
  },
  methods: {
    GetGlobalOptions: function() {
      BookingService.GetGlobalOptions()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let EntrySettings = data.Records.filter(
              x => x.go_key == "ENTRY_ID_REQUIRED_QRAPP"
            );
            // console.log(EntrySettings, "EntrySettings");
            if (EntrySettings && EntrySettings.length > 0) {
              this.entry_id_required = EntrySettings[0].go_value;

              window.localStorage.setItem(
                "STBASEDENTRY",
                EntrySettings[0].go_value
              );
            } else {
              window.localStorage.setItem("STBASEDENTRY", "N");
            }
            let ClientSettings = data.Records.filter(
              x => x.go_key === "CLIENT_SETUP_NAME"
            );

            if (ClientSettings) {
              window.localStorage.setItem(
                "CLIENT_NAME",
                ClientSettings[0].go_value
              );
            }
          } else {
            window.localStorage.setItem("STBASEDENTRY", "N");
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("catch error on GetGlobalOptions :", error);
        });
    },
    onDecode(decodedString) {
      console.log("test");
      console.log("decodedString :", decodedString);
    },
    onLogout() {
      this.sidebar = false;
      window.localStorage.removeItem("JWT_TOKEN");
      window.localStorage.removeItem("USERCINEINFO");
      window.localStorage.clear();
      this.$cookie.delete("BRHSID");
      this.$router.push({
        name: "login"
      });
      return window.caches.keys();
    },
    closeSettingsDropdown() {
      this.settingsDropdownOpen = false;
    },
    openDefaultPageModal() {
      this.settingsDropdownOpen = false;
      // Reload current preference from cookie before opening
      const savedDefault = this.$cookie.get("BRIJ_DEFAULT_PAGE");
      if (savedDefault) {
        this.selectedDefaultPage = savedDefault;
      }
      this.showDefaultPageModal = true;
    },
    closeDefaultPageModal() {
      this.showDefaultPageModal = false;
    },
    saveDefaultPage() {
      this.$cookie.set("BRIJ_DEFAULT_PAGE", this.selectedDefaultPage, {
        expires: "1Y",
      });
      this.showDefaultPageModal = false;
      const label = this.selectedDefaultPage === "manual" ? "Manual Entry" : "QR Scanner";
      this.$toasted.show("Default page set to " + label);
    },
  }
};
</script>

<style>
.btn-sidebar {
  /* left: 10px;
  top: 20px; */
  border: none;
  /* position: absolute; */
  background-color: transparent;
}
.backdrop {
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: block;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.75);
}
.app-aside {
  top: 0;
  padding-top: 30px;
  left: -275px;
  width: 275px;
  z-index: 111;
  height: 100vh;
  position: fixed;
  transition: left 0.3s ease;
  background: #d3d3d3;
}

.app-aside.active {
  left: 0;
}

.app-aside a {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #404040;
  padding: 10px 15px;
}

.app-aside a:hover {
  text-decoration: none;
}

/* Settings gear button */
.settings-wrapper {
  position: relative;
  margin-right: 8px;
}

.btn-settings {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.btn-settings:hover {
  background-color: rgba(3, 45, 110, 0.1);
}

.btn-settings:focus {
  outline: none;
}

/* Settings dropdown */
.settings-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 200;
  overflow: hidden;
  animation: dropdownFadeIn 0.2s ease;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.settings-dropdown-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.settings-dropdown-item:hover {
  background-color: #f0f4fa;
  color: #032D6E;
}

/* Modal overlay */
.settings-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: modalOverlayFadeIn 0.2s ease;
}

@keyframes modalOverlayFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Modal */
.settings-modal {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 380px;
  padding: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: modalSlideIn 0.25s ease;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.settings-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.settings-modal-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #122C6A;
}

.settings-modal-close {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.settings-modal-close:hover {
  background-color: #f0f0f0;
  color: #333;
}

.settings-modal-close:focus {
  outline: none;
}

.settings-modal-desc {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

/* Option cards */
.settings-modal-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.settings-option {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
}

.settings-option:hover {
  border-color: #b0c4de;
  background-color: #f8fafd;
}

.settings-option-active {
  border-color: #032D6E;
  background-color: #f0f4fa;
  box-shadow: 0 0 0 1px #032D6E;
}

.settings-option-radio {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #ccc;
  margin-right: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: border-color 0.2s ease;
}

.settings-option-active .settings-option-radio {
  border-color: #032D6E;
}

.settings-option-radio-inner {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #032D6E;
  animation: radioFadeIn 0.15s ease;
}

@keyframes radioFadeIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

.settings-option-content {
  display: flex;
  flex-direction: column;
}

.settings-option-title {
  font-size: 15px;
  font-weight: 600;
  color: #222;
}

.settings-option-subtitle {
  font-size: 12px;
  color: #888;
  margin-top: 2px;
}

.settings-modal-save {
  margin-top: 4px;
}
</style>




// WEBPACK FOOTER //
// src/App.vue